'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' });

var Publish = function Publish(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Publish = (0, _pure2.default)(Publish);
Publish.muiName = 'SvgIcon';

exports.default = Publish;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Publish.js
// module id = 2745
// module chunks = 0